__turbopack_context__.v({
  "article-body": "ArticleBody-module-scss-module__Ik8DHW__article-body",
  "good-to-know": "ArticleBody-module-scss-module__Ik8DHW__good-to-know",
  "image": "ArticleBody-module-scss-module__Ik8DHW__image",
  "landscape": "ArticleBody-module-scss-module__Ik8DHW__landscape",
  "portrait": "ArticleBody-module-scss-module__Ik8DHW__portrait",
  "quote": "ArticleBody-module-scss-module__Ik8DHW__quote",
  "quote-wrapper": "ArticleBody-module-scss-module__Ik8DHW__quote-wrapper",
  "rich-text": "ArticleBody-module-scss-module__Ik8DHW__rich-text",
  "table": "ArticleBody-module-scss-module__Ik8DHW__table",
  "video": "ArticleBody-module-scss-module__Ik8DHW__video",
  "video-wrapper": "ArticleBody-module-scss-module__Ik8DHW__video-wrapper",
  "vimeo": "ArticleBody-module-scss-module__Ik8DHW__vimeo",
});
